import { memo, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import AttachFiles from "@coworker/apprestructured/src/task-management/components/AttachFiles/AttachFiles";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";

function AttachFilesDemo() {
  const [files, setFiles] = useState<File[]>([]);
  const [disabled, setDisabled] = useState(false);

  return (
    <Demo>
      <Name>AttachFiles</Name>
      <Highlight>
        <FixaListView id="attachfiles" size="small">
          <AttachFiles
            files={files}
            onFilesChanged={setFiles}
            disabled={disabled}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="attachfilesdemo-disabled"
          id="attachfilesdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(AttachFilesDemo);
